import React, {  Component } from 'react';
import { connect } from 'react-redux';

class IrrevocablyInoperableOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('IrrevocablyInoperableOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">IRREVOCABLY INOPERABLE PRODUCTS</h2>
                    <p>After the serial tag has been removed, the ASM must verify that the unit has been rendered completely and irrevocably inoperable by:</p>
                    <ul className="pad-b-1em">
                        <li>
                            Cutting electrical cords
                        </li>
                        <li>
                            Destroying appliance controls
                        </li>
                        <li>
                            Damaging door seal
                        </li>
                        <li>
                            Damaging, puncturing, or crushing cabinet
                        </li>
                        <li>
                            Damaging capacitor starter (refrigerators, freezers, and A/C)
                        </li>
                        <li>
                            Damaging fan motors (cutting electrical cords to motors if possible)
                        </li>
                        <li>
                            Microwaves: Destroying door seal and control panel only
                        </li>
                    </ul>
                    <p>No functional parts are to be removed or salvaged by the dealer. It is the dealer’s responsibility to lawfully dispose of the scrapped unit.</p>
                    {/*Mobile view */}
                    <a className="blueButton d-none d-sm-block" onClick={this.closeDialog.bind(this)}>Ok</a>
                    
                    <a className="blueButton float-right d-block d-sm-none" onClick={this.closeDialog.bind(this)}>Ok</a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

IrrevocablyInoperableOverlayDialog = connect(mapStateToProps)(IrrevocablyInoperableOverlayDialog);
export default IrrevocablyInoperableOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/irrevocablyInoperableOverlayDialog.js